function imageUpload() {
    if (!Vue) Vue = window.Vue;
    Vue.component('imagepreview', {
        props: ['value', 'options'],
        template: '<div class="imagepreview">'
            + '<div v-if="options && options.draggable" class="controls pull-left"><i ref="movehandle" class="movehandle fa fa-arrows"/></div>'
            + '<div v-if="options && options.canEdit" class="controls pull-right"><i ref="edit" class="fa fa-pencil"/> <i ref="delete" class="fa fa-times"/></div>'
            + '<div v-if="options && options.canDeleteOnly" class="controls pull-right"> <i ref="delete" class="fa fa-times"/></div>'
            + '<div ref="preview" class="preview" v-on:click="previewClicked()"><i class="fa fa-spinner fa-spin" v-if="isFileReading"/></div>'
            + '</div>',
        data: function () {
            return {
                isFileReading: false

            };
        },
        methods: {
            previewClicked: function () {
                if (this.value.embedMarkup) {
                    var previewMarkup = this.value.embedMarkup;
                    previewMarkup = this.value.embedMarkup.replace(/width="(\d*)" height="(\d*)"/, 'width="100%" height="100%"');
                    this.preview.innerHTML = '<div class="preview-image">' + previewMarkup + '</div>';
                }
            },
            updatePreview: function (self) {

                if (self.value && self.value.constructor && (self.value.constructor.name === 'File' || self.value.constructor.name === 'Blob')) {
                    //value is a file that has just been dropped or selected in file input
                    var reader = new FileReader();
                    self.isFileReading = true;
                    reader.onload = function (e) {
                        if (e.target.result) {
                            // create new image
                            self.image = document.createElement('div');
                            self.image.classList.add('preview-image');
                            self.image.style.backgroundImage = 'url(' + e.target.result + ')';
                            self.preview.innerHTML = '';
                            self.preview.appendChild(self.image);

                            // clean result before
                            self.preview.innerHTML = '';
                            // append new image
                            self.preview.appendChild(self.image);
                            self.isFileReading = false;
                        }
                    };
                    reader.error = function () {
                        self.isFileReading = false;
                    };
                    reader.readAsDataURL(self.value);
                } else {
                    //value is photo record from db
                    self.image = document.createElement('div');
                    self.image.classList.add('preview-image');
                    self.image.style.backgroundImage = 'url("' + self.value.originalUrl + '?autorotate=true&w=' + self.preview.offsetWidth + '")';
                    self.preview.innerHTML = '';
                    self.preview.appendChild(self.image);
                }
            }
        },
        mounted: function () {
            var self = this;

            self.preview = this.$refs.preview;
            self.edit = this.$refs.edit;
            self.edit && self.edit.addEventListener('click', function () {
                self.$emit('edit');
            });
            self.delete = this.$refs.delete;
            self.delete && self.delete.addEventListener('click', function () {
                self.$emit('delete');
            });

            this.$nextTick(function () {
                self.updatePreview(self);

                return;

            });
        },
        watch: {
            value: function () {
                this.updatePreview(this);
            }
        }
    });

    return Vue.component('imageupload2', {
        props: ['value', 'options'],
        template: '<div ref="droparea" class="imageupload droparea form-photo" >'
            + '<input ref="upload" type="file" multiple/>'
            + '<span class="hidden-xs"> Drop Photos Here or Click to Upload</span>'
            + '<span class="visible-xs">Tap to Upload a Photo</span>'
            + '</div>',
        data: function () {
            return {

            };
        },
        mounted: function () {
            var self = this;


            this.$nextTick(function () {

                var el = this.$el;

                var upload = this.$refs.upload;
                var droparea = this.$refs.droparea;


                if (droparea.offsetWidth)// 0 if not displayed.  need a better fix here...
                    droparea.style.height = (droparea.offsetWidth / self.options.aspectRatio) + 'px';

                upload.addEventListener('change', function (ev) {
                    self.handleFiles.call(self, upload.files);
                    upload.value = "";
                });

                droparea.addEventListener('click', function () {
                    upload.click();
                });
                droparea.addEventListener('dragover', function (ev) {
                    ev.preventDefault(); //TODO: css
                    ev.dataTransfer.dropEffect = "copy";
                });
                droparea.addEventListener('drop', function (ev) {
                    ev.preventDefault();
                    self.handleFiles.call(self, ev.dataTransfer.files);
                });



                return;

            });
        },
        methods: {
            resizeImage:function(file) {
                console.log('resizeImage 1');
                return new Promise(function(resolve, reject) {
                  var reader = new FileReader();
                  console.log('resizeImage 2');
                  reader.onload = function(event){
                    var img = new Image();
                    img.src = event.target.result;
                    console.log('resizeImage 3');
                    img.onload = function() {
                      console.log('resizeImage 4');
                      var elem = document.createElement('canvas');
                      var MAX_WIDTH = 2000;
                      var MAX_HEIGHT = 2000;
                      var width = img.width;
                      var height = img.height;
                      if (width > height) {
                        if (width > MAX_WIDTH) {
                          height *= MAX_WIDTH / width;
                          width = MAX_WIDTH;
                        }
                      } else {
                        if (height > MAX_HEIGHT) {
                          width *= MAX_HEIGHT / height;
                          height = MAX_HEIGHT;
                        }
                      }
                      elem.width = width;
                      elem.height = height;
                      var ctx = elem.getContext('2d');
                      ctx.drawImage(img, 0, 0, width, height);
                      ctx.canvas.toBlob(function(blob){
                        console.log('resizeImage 5');
                        var resizedFile = new File([blob], 'image.jpg', { type: 'image/jpeg', lastModified: Date.now() });
                        resolve(resizedFile);
                      }, 'image/jpeg', .8);
                    }
                      reader.onerror = function (error) { reject(error); }
                  }
                  reader.readAsDataURL(file);
                  console.log('resizeImage 6');
                });
              },
            handleFiles: function (files) {
                var self = this;
                if (this.value === null) this.value = [];
                //TODO: resize to fit site max? https://stackoverflow.com/questions/23945494/use-html5-to-resize-an-image-before-upload
                for (var i = 0; i < files.length; i++) {
                    this.resizeImage(files[i]).then(
                        function(resizedFile){
                            resizedFile.tid = new Date().getTime() + i;
                            self.value.unshift(resizedFile);
                             self.$emit('input', self.value);
                        }, function(e) {
                            //TODO: some error thing?
                            console.log(e);
                            throw 'Error resizing image.';
                        }
                    )                                      
                }
               
            },
            pickFiles: function () {
                this.$refs.upload.click();
            }
        }
    });

    //return Vue.component('imageupload', {
    //    props: ['value', 'options'],
    //    template: '<div class="imageupload">'
    //        + '<input ref="upload" type="file"  />'
    //        + '<div ref="preview" class="preview"> Click to Upload a Photo or Drop Photos Here.</div>'
    //        // + '<button ref="uploadButton"><i class="fa fa-upload"></i></button>'
    //        + '<button ref="editButton" v-bind:class="{\'hidden\':!state.hasImage || state.isEditing}"><i class="fa fa-pencil"></i></button>'
    //        + '<button ref="rotateButton" v-bind:class="{\'hidden\':!state.hasImage || !state.isEditing}"><i class="fa fa-repeat"></i></button>'
    //        + '<button ref="saveButton" v-bind:class="{\'hidden\':!state.hasImage || !state.isEditing}"><i class="fa fa-save"></i></button>'
    //        + '</div>',
    //    data: function () {
    //        return {
    //            state: { isEditing: false, hasImage: false }
    //        }
    //    },
    //    mounted: function () {
    //        var self = this;


    //        this.$nextTick(function () {

    //            var el = this.$el;
    //            var copperOptions = self.options || { aspectRatio: .75 };


    //            var upload = this.$refs.upload;
    //            var preview = this.$refs.preview;
    //            var uploadButton = this.$refs.uploadButton;
    //            var editButton = this.$refs.editButton;
    //            var saveButton = this.$refs.saveButton;
    //            var rotateButton = this.$refs.rotateButton;

    //            var handleFiles = function (files) {
    //                self.value = file;
    //                self.$emit('input', self.value);
    //                var reader = new FileReader();
    //                reader.onload = function (e) {
    //                    if (e.target.result) {
    //                        if (self.cropper) self.cropper.destroy();
    //                        if (self.state.isEditing) self.state.isEditing = false;
    //                        // create new image
    //                        self.image = document.createElement('img');
    //                        self.image.src = e.target.result;
    //                        self.state.hasImage = true;
    //                        // clean result before
    //                        preview.innerHTML = '';
    //                        // append new image
    //                        preview.appendChild(self.image);

    //                        self.$refs.upload.value = "";
    //                    }
    //                };
    //                reader.readAsDataURL(file);
    //            }

    //            preview.style.height = (preview.offsetWidth / copperOptions.aspectRatio) + 'px';
    //            preview.addEventListener('click', function () {
    //                if (!self.state.isEditing) upload.click();
    //            });
    //            preview.addEventListener('dragover', function (ev) {
    //                ev.preventDefault(); //TODO: css
    //                ev.dataTransfer.dropEffect = "copy";
    //            });
    //            preview.addEventListener('drop', function (ev) {
    //                ev.preventDefault();
    //                handleFile(ev.dataTransfer.files[0]);
    //            });



    //            rotateButton.addEventListener('click', function () {
    //                self.cropper.rotate(90);
    //            });


    //            editButton.addEventListener('click', function () {
    //                self.cropper = new Cropper(self.image, copperOptions);
    //                self.state.isEditing = true;
    //            });
    //            saveButton.addEventListener('click', function () {
    //                var croppedCanvas = self.cropper.getCroppedCanvas();
    //                self.image.src = croppedCanvas.toDataURL('image/jpeg', 1);
    //                croppedCanvas.toBlob(function (blob) {
    //                    self.value = blob;
    //                    self.$emit('input', self.value);
    //                    self.cropper.destroy();
    //                    self.state.isEditing = false;
    //                }, 'image/jpeg', 1);

    //            });
    //            upload.addEventListener('change', function (e) {
    //                if (e.target.files.length) {
    //                    // start file reader
    //                    handleFile(e.target.files[0]);

    //                }
    //            });

    //            return;

    //        });
    //    }
    //});
}